import { render, staticRenderFns } from "./AccountRefunds.vue?vue&type=template&id=10e762b6&"
import script from "./AccountRefunds.vue?vue&type=script&lang=js&"
export * from "./AccountRefunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports